<template>
    <span>
        {{ text|truncate(this.characters) }}
    </span>
</template>

<script>
    export default {
        props: {
            characters: {
                default: 35,
            },
        },
        computed: {
            text() {
                return this.$slots.default.map(vnode => (vnode.text || vnode.elm.innerText)).join('');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/SeoTruncate.vue